import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { OrgChartPage } from "@/components/org-chart/org-chart-page";
import { Route as authenticatedFullBleedRoute } from "../_authenticatedFullBleed";

export const Route = createRoute({
  getParentRoute: () => authenticatedFullBleedRoute,
  path: "/org-chart",
  shouldReload: true,
  loader: async () => {
    const res = await fetch("/api/org-chart");
    if (!res.ok) throw new Error("Failed to load org chart data");
    const data = await res.json();
    return {
      owners: data.owners ?? [],
      isAdmin: data.isAdmin ?? false,
      hasReports: data.hasReports ?? true,
    };
  },
  component: OrgChartPageGuard,
});

function OrgChartPageGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();
  // biome-ignore lint/suspicious/noExplicitAny: route type not yet in TanStack Router's generated types
  const { hasReports, isAdmin } = Route.useLoaderData() as any;

  const role = (session?.user as any)?.role;

  // Admin always has access; non-admin needs direct reports
  if (role !== "admin" && !hasReports) {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <OrgChartPage readOnly={!isAdmin} isAdmin={isAdmin} />;
}
